import React from 'react';
import { useSelector } from 'react-redux';
import { ButtonGroup, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Input, Button } from "reactstrap";
import { createSelector } from 'reselect';
import checkPermission from '../../../Components/Hooks/PermissionHook';

function NewFolderDropdown({ newFolderFunction }) {
  const selectRoutePath = createSelector(state => state.MenuData, state => ({
    brandPath: state.brandPath,
    marketPath: state.marketPath,
  }));
  const { brandPath, marketPath } = useSelector(selectRoutePath);

  function handleSubmit(e) {
    e.preventDefault();
    newFolderFunction({ name: e.target.name.value });
    e.target.name.value = "";
  }

  if (checkPermission((marketPath ? "markets" : "brands"), (marketPath ? marketPath : brandPath), "folderCreate")) {
    return (
      <ButtonGroup>
        <UncontrolledDropdown>
          <DropdownToggle tag="button" className='btn btn-info'>
            <i className='ri-folder-line align-bottom me-2'></i>
            New Folder
          </DropdownToggle>
          <DropdownMenu className='dropdown-menu-lg p-4'>
            <form onSubmit={handleSubmit}>
              <div className='mb-3'>
                <Input type='text' name='name' id='name' placeholder='Name your folder' style={{ minWidth: "270px" }} />
              </div>
              <div className='w-100 d-flex flex-column flex-sm-row justify-content-end gap-2'>
                <Button tabIndex="0" role='menuitem' type='button' color='light'>Close</Button>
                <Button type='submit' color='info'>Create folder</Button>
              </div>
            </form>
          </DropdownMenu>
        </UncontrolledDropdown>
      </ButtonGroup>
    )
  } else {
    return null;
  }

}

export default NewFolderDropdown;